angular.module('gym.calendar').controller('OnlineMeetingsCtrl', ["$scope", "$rootScope", "$http", "$state", "$timeout", "EmploymentService", "TrainersService", "CalendarData", "ReactModal", "EventService", "CwStorage", "loadingAnimation", "locations", "selectedLocation", "eventTypes", "styles", function($scope, $rootScope, $http, $state, $timeout, EmploymentService, TrainersService, CalendarData, ReactModal, EventService, CwStorage, loadingAnimation, locations, selectedLocation, eventTypes, styles) {
  var getEvents, getEventsDebounced, groupEvents, gym, loadMoreCount, loadMoreLimit, onFiltersChange, save;
  gym = $rootScope.gym;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.queryParams = {
    general_filter: CwStorage.getItem('calendarGeneralFilter')
  };
  $scope.locations = locations;
  $scope.instructors = TrainersService.get();
  $scope.eventTypes = eventTypes;
  $scope.styles = styles;
  $scope.selectedLocations = _.compact([selectedLocation]);
  $scope.selectedInstructors = [];
  $scope.selectedEventTypes = [];
  $scope.selectedStyles = [];
  $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
  $scope.glossary = gym.glossary;
  $scope.date = moment().startOf('week');
  $scope.eventsByDay = {};
  loadMoreLimit = 20;
  loadMoreCount = 0;
  $scope.eventsCount = 0;
  if ($scope.unableToManageOtherContacts) {
    $scope.selectedInstructors = [
      {
        id: window.currentUser.id,
        name: `${window.currentUser.first_name} ${window.currentUser.last_name}`
      }
    ];
  }
  onFiltersChange = function() {
    $scope.loadMoreDate = null;
    $scope.eventsByDay = {};
    loadMoreCount = 0;
    return $scope.eventsCount = 0;
  };
  $scope.goToCalendar = function() {
    return $state.go('gym.calendar');
  };
  groupEvents = function(events) {
    return _.chain(events).map(function(event) {
      event.date = moment(event.start, 'YYYY/MM/DD HH:mm').startOf('day').format('X');
      return event;
    }).groupBy('date').value();
  };
  getEvents = function() {
    var date, end, params, selectedEventType, selectedInstructor, selectedStyle, start;
    date = $scope.loadMoreDate || $scope.date;
    start = date.clone().startOf('day');
    end = date.clone().endOf('week');
    selectedLocation = $scope.selectedLocations[0] || {};
    selectedInstructor = $scope.selectedInstructors[0] || {};
    selectedEventType = $scope.selectedEventTypes[0] || {};
    selectedStyle = $scope.selectedStyles[0] || {};
    params = {
      start: start.format('X'),
      end: end.format('X'),
      location_id: selectedLocation.id,
      instructor_id: selectedInstructor.id,
      event_type_id: selectedEventType.id,
      style_id: selectedStyle.id,
      view: 'online_meetings',
      '_': new Date().getTime()
    };
    angular.extend(params, $scope.queryParams);
    $scope.title = `Events starting from ${$scope.date.format('MMM D, YYYY')}`;
    $scope.isLoading = true;
    return CalendarData.getList(params).then(function(events) {
      $scope.isLoading = false;
      _.extend($scope.eventsByDay, groupEvents(events.plain()));
      return $scope.eventsCount = $scope.eventsCount + events.length;
    });
  };
  getEvents();
  getEventsDebounced = _.debounce(function() {
    return getEvents();
  }, 300);
  $rootScope.$on('calendar:updated', function() {
    return getEvents();
  });
  $scope.onParamsChange = function() {
    CwStorage.setItem('calendarGeneralFilter', $scope.queryParams.general_filter);
    return getEvents();
  };
  $scope.loadMore = function() {
    var date;
    if ($scope.isLoading || loadMoreCount >= loadMoreLimit) {
      return;
    }
    loadMoreCount = loadMoreCount + 1;
    date = $scope.loadMoreDate || $scope.date;
    $scope.loadMoreDate = date.clone().endOf('week').add(1, 'days');
    return getEvents();
  };
  $scope.isFiltersAvailable = function() {
    return $scope.locations.length > 1 || $scope.instructors.length > 1;
  };
  $scope.onLocationsChange = function(locations) {
    var location;
    onFiltersChange();
    location = locations[0] || {};
    CwStorage.setItem('selectedLocation', location.id);
    $scope.selectedLocations = locations;
    return getEventsDebounced();
  };
  $scope.onInstructorsChange = function(instructors) {
    var instructor;
    onFiltersChange();
    instructor = instructors[0] || {};
    $scope.selectedInstructors = instructors;
    return getEventsDebounced();
  };
  $scope.onEventTypesChange = function(eventTypes) {
    onFiltersChange();
    $scope.selectedEventTypes = eventTypes;
    return getEventsDebounced();
  };
  $scope.onStylesChange = function(styles) {
    onFiltersChange();
    $scope.selectedStyles = styles;
    return getEventsDebounced();
  };
  $scope.toDate = function(date) {
    onFiltersChange();
    $scope.date = date;
    return getEvents();
  };
  $scope.getInstructors = function(event) {
    var ref;
    if ((ref = event.instructor_names) != null ? ref.length : void 0) {
      return event.instructor_names.join(', ');
    } else {
      return event.instructor_name;
    }
  };
  $scope.showAttendees = function(event) {
    return EventService.showAttendees(event);
  };
  $scope.copyMeetingUrlModal = function(event) {
    return ReactModal.open({
      component: 'CopyOnlineMeetingsModal',
      props: {
        event: event
      }
    }).then(function() {
      return getEvents();
    }, function() {
      return getEvents();
    });
  };
  save = function(event) {
    var params, url;
    params = {
      meeting_url: event.meeting_url,
      meeting_instructions: event.meeting_instructions
    };
    url = `/gyms/${gym.id}/calendar/events/${event.id}/update_meeting_details`;
    event.success = null;
    event.errors = null;
    return $http.put(url, {
      event: params
    }).then(function() {
      event.success = true;
      return $timeout(function() {
        return event.success = null;
      }, 2000);
    }, function(response) {
      return event.errors = response.data.errors;
    });
  };
  $scope.saveMeetingDetails = function(event) {
    return save(event);
  };
  return $scope.onMeetingDetailsChange = _.debounce(function(event) {
    return save(event);
  }, 1000);
}]);
